import {useEffect} from 'preact/hooks';

import {useDeliveryEstimate} from 'utilities/delivery-promise';
import {useProductDetails} from 'utilities/product';
import {widgetLoadWebPixel} from 'utilities/web-pixels';
import {useErrorLogger} from 'utilities/error-logger';

interface Props {
  className?: string;
}

export function OptimusButton({className}: Props) {
  const {productDetails, variantId} = useProductDetails();
  const {deliveryEstimate, variantId: deliveryEstimateVariantId} =
    useDeliveryEstimate();
  const {reportError} = useErrorLogger();

  useEffect(() => {
    if (
      deliveryEstimate &&
      deliveryEstimateVariantId === variantId &&
      productDetails &&
      variantId
    ) {
      widgetLoadWebPixel({
        deliveryEstimate,
        productDetails,
        variantId,
        reportError,
      });
    }
  }, [
    deliveryEstimate,
    productDetails,
    variantId,
    deliveryEstimateVariantId,
    reportError,
  ]);

  return <slot name="generic-promise" className={className} />;
}
